<template>
	<div>
		<div
			class="color-picker"
			v-if="!unique"
		>
			<Color
				v-for="(color, idx) in colors"
				:key="`color-${idx}`"
				:color="color.colorCode"
				:label="color.label"
				:show-label="showLabel(color.colorCode)"
				:size="size"
				:href="color.link"
				:active="modelValue === color.colorCode"
				:disabled="disableColorsNotInStock && !color.inStock"
				@click="$emit('update:modelValue', color.colorCode)"
				@set-hovered="setHovered"
				@remove-hovered="removeHovered"
				@set-focused="setFocused"
				@remove-focused="removeFocused"
				class="color"
			/>
		</div>
		<div
			class="color-picker"
			v-else
		>
			<Color
				v-for="unique in uniqueColors"
				:key="unique.color.colorCode"
				:color="unique.color.colorCode"
				:label="unique.color.label"
				:show-label="showLabel(unique.color.colorCode)"
				:size="size"
				:href="unique.color.link"
				:active="modelValue === unique.color.colorCode"
				:disabled="disableColorsNotInStock && !unique.color.inStock"
				@click="$emit('update:modelValue', unique.color.colorCode)"
				@set-hovered="setHovered"
				@remove-hovered="removeHovered"
				@set-focused="setFocused"
				@remove-focused="removeFocused"
				class="color"
			>
			</Color>
		</div>
	</div>
</template>

<script>
export default defineNuxtComponent({
	name: "ColorPicker",

	props: {
		unique: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			validator: (input) => ["sm", "md", "lg"].includes(input),
		},
		colors: {
			type: Array,
		},
		modelValue: {
			type: String,
		},
		disableColorsNotInStock: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		currentHover: "",
		currentFocused: "",
	}),

	computed: {
		uniqueColors() {
			const unique = this.colors.filter((value, index, self) => {
				return self.indexOf(value) === index;
			});
			const mapped = this.colors.map((value, index) => {
				return { color: value, index: index };
			});
			const mappedUnique = [];

			for (const color of unique) {
				const found = mapped.find((value) => {
					if (value.color === color) return true;
				});

				mappedUnique.push(found);
			}

			return mappedUnique;
		},
	},

	methods: {
		setHovered(value) {
			this.currentHover = value;
		},
		removeHovered(value) {
			this.currentHover = this.currentHover === value ? "" : this.currentHover;
		},
		setFocused(value) {
			this.currentFocused = value;
		},
		removeFocused(value) {
			this.currentFocused = this.currentFocused === value ? "" : this.currentFocused;
		},
		showLabel(colorCode) {
			const active = !!(this.modelValue === colorCode);
			if (this.currentFocused === colorCode) return true;
			if (this.currentFocused && this.currentFocused !== colorCode) return false;
			if (!this.currentFocused && this.currentHover === colorCode) return true;
			if (this.currentHover && this.currentHover !== colorCode) return false;
			if (!this.currentFocused && !this.currentHover && active) return true;

			return false;
		},
	},
});
</script>

<style lang="scss" scoped>
.color-picker {
	display: inline-flex;
	flex-wrap: wrap;

	.color + .color {
		margin-left: $spacing-s;
	}
}
</style>
